import { CanActivateAuthGuard } from './core/security/auth-gaurd.service';
import { UsersComponent } from './components/users/users.component';
import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule, CanActivate } from '@angular/router';
import { UserListComponent } from './components/users/user-list/user-list.component';
import { RequestsComponent } from './components/requests/requests.component';
import { SuppliersComponent } from './components/suppliers/suppliers.component';
import { UploadSupplierComponent } from './components/suppliers/upload-suppliers/upload-supplier.component';
import { SupplierListComponent } from './components/suppliers/list/list.component';
import { CustomersComponent } from './components/customers/customers.component';
import { CustomerListComponent } from './components/customers/list/list.component';
import { CustomerComponent } from './components/customers/customer/customer.component';
import { SupplierComponent } from './components/suppliers/supplier/supplier.component';
import { AddCustomerUserComponent } from './components/users/add-customer-user/add-customer-user.component';
import { CreateCustomerComponent } from './components/users/add-customer-user/create/create.component';
import { ConfirmCustomerComponent } from './components/users/add-customer-user/confirm/confirm.component';
import { UpdateCustomerUserComponent } from './components/users/update-customer-user/update-customer-user.component';
import { UpdateCustomerComponent } from './components/users/update-customer-user/update/update.component';
import { ConfirmUpdateCustomerComponent } from './components/users/update-customer-user/confirm-update/confirm-update.component';
import { AddSupplierUserComponent } from './components/users/add-supplier-user/add-supplier-user.component';
import { CreateSupplierComponent } from './components/users/add-supplier-user/create/create.component';
import { ConfirmSupplierComponent } from './components/users/add-supplier-user/confirm/confirm.component';
import { UpdateSupplierUserComponent } from './components/users/update-supplier-user/update-supplier-user.component';
import { UpdateSupplierComponent } from './components/users/update-supplier-user/update/update.component';
import { ConfirmUpdateSupplierComponent } from './components/users/update-supplier-user/confirm-update/confirm-update.component';
import { AddCarrierUserComponent } from './components/users/add-carrier-user/add-carrier-user.component';
import { CreateCarrierComponent } from './components/users/add-carrier-user/create/create.component';
import { ConfirmCarrierComponent } from './components/users/add-carrier-user/confirm/confirm.component';
import { UserMassUploadComponent } from './components/users/user-mass-upload/user-mass-upload.component';
import { UpdateCarrierUserComponent } from './components/users/update-carrier-user/update-carrier-user.component';
import { UpdateCarrierComponent } from './components/users/update-carrier-user/update/update.component';
import { MaintenanceComponent } from './shared/components/maintenance/maintenance.component';
import { ConfirmUpdateCarrierComponent } from './components/users/update-carrier-user/confirm-update/confirm-update.component';
import { CarrierUserRequestAccessComponent } from './components/users/add-carrier-user/carrier-request-access/carrier-user-request-access.component';
import { MassUploadComponent } from './components/suppliers/mass-upload/mass-upload.component';
import { RequestAccessComponent } from './components/admin-requests/request-access.component';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { AnnouncementsComponent } from './shared/components/announcements/announcements.component';

const routes: Routes = [
  {
    path: 'requests', component: RequestsComponent,
    canActivate: [CanActivateAuthGuard]
  },
  { path: '', redirectTo: 'users', pathMatch: 'full' },
  {
    path: 'add-customer-user',
    component: AddCustomerUserComponent,
    canActivate: [CanActivateAuthGuard],
    children: [
      { path: '', redirectTo: 'create', pathMatch: 'full' },
    ]
  },
  { outlet: 'cust', path: 'create', component: CreateCustomerComponent },
  { outlet: 'cust', path: 'confirm', component: ConfirmCustomerComponent },
  {
    path: 'update-customer-user',
    component: UpdateCustomerUserComponent,
    canActivate: [CanActivateAuthGuard],
    children: [
      { path: '', redirectTo: 'update', pathMatch: 'full' },
      { path: 'update', component: UpdateCustomerComponent },
      { path: 'confirm-update', component: ConfirmUpdateCustomerComponent }
    ]
  },
  { path: 'announcements', component: AnnouncementsComponent },
  { outlet: 'sup', path: 'create', component: CreateSupplierComponent },
  { outlet: 'sup', path: 'confirm', component: ConfirmSupplierComponent },

  {
    path: 'suppliers', component: SuppliersComponent,
    canActivate: [CanActivateAuthGuard],
    children: [
      { path: 'upload-supplier', component: UploadSupplierComponent },
      { path: '', redirectTo: 'all', pathMatch: 'full' },
      { path: 'mass-upload', component: MassUploadComponent },
      { path: ':filter', component: SupplierListComponent }
    ]
  },
  {
    path: 'customers', component: CustomersComponent,
    canActivate: [CanActivateAuthGuard],
    children: [
      { path: '', redirectTo: 'all', pathMatch: 'full' },
      { path: ':filter', component: CustomerListComponent }
    ]
  },
  {
    path: 'carriers/request-access', component: CarrierUserRequestAccessComponent
  },

  { path: 'request-access', component: RequestAccessComponent },
  { path: 'customer/:id', component: CustomerComponent, canActivate: [CanActivateAuthGuard] },
  { path: 'supplier/:id', component: SupplierComponent, canActivate: [CanActivateAuthGuard] },
  {
    path: 'update-supplier-user',
    component: UpdateSupplierUserComponent,
    canActivate: [CanActivateAuthGuard],
    children: [
      { path: '', redirectTo: 'update', pathMatch: 'full' },
      { path: 'update', component: UpdateSupplierComponent },
      { path: 'confirm-update', component: ConfirmUpdateSupplierComponent }
    ]
  },
  {
    path: 'add-carrier-user',
    component: AddCarrierUserComponent,
    canActivate: [CanActivateAuthGuard],
    children: [
      { path: '', redirectTo: 'create', pathMatch: 'full' },
      { path: 'create', component: CreateCarrierComponent },
      { path: 'confirm', component: ConfirmCarrierComponent }
    ]
  },
  {
    path: 'update-carrier-user',
    component: UpdateCarrierUserComponent,
    canActivate: [CanActivateAuthGuard],
    children: [
      { path: '', redirectTo: 'update', pathMatch: 'full' },
      { path: 'update', component: UpdateCarrierComponent },
      { path: 'confirm-update', component: ConfirmUpdateCarrierComponent }
    ]
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [CanActivateAuthGuard],
    children: [
      { path: '', redirectTo: 'all', pathMatch: 'full' },
      { path: ':filter', component: UserListComponent },
      { path: 'mass-upload', component: UserMassUploadComponent },
    ]
  },
  {
    path: 'users-mass-upload',
    component: UserMassUploadComponent,
    canActivate: [CanActivateAuthGuard]
  },
  {
    path: 'my-account',
    component: MyAccountComponent
  },
  {
    path: '**',
    component: MaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
